import { Type } from '@angular/core';
import { DATA_LAYER_SERVICE, GoogleAnalyticsDataLayerService } from '@lx/shared/google-analytics';

export const getGoogleAnalyticsProvider = (googleAnalyticsDataLayerService: Type<GoogleAnalyticsDataLayerService>) => {
  return { provide: DATA_LAYER_SERVICE, useClass: googleAnalyticsDataLayerService };
};
